var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogoBallad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#004352"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55322 51.9533C14.1594 45.3331 21.8236 41 30.4998 41C38.9253 41 46.3965 45.0863 51.0395 51.3853C45.6248 56.713 38.1962 60 29.9998 60C22.0988 60 14.9111 56.9456 9.55322 51.9533Z",
    fill: "#1DDFEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.57 24.5C47.9901 24.5 38.9966 8.59007 31.2835 22.2298C38.9905 8.59007 21.0034 8.59007 28.7165 22.2298C21.0095 8.59007 12.0159 24.5 27.43 24.5C12.0099 24.5 21.0034 40.4099 28.7165 26.7702C21.0095 40.4099 38.9966 40.4099 31.2835 26.7702C38.9905 40.4161 47.9841 24.5 32.57 24.5Z",
    fill: "#1DDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogoBallad);
export default __webpack_public_path__ + "static/media/user-logo-ballad.afce1310baf3b74961eaae5abd5ec349.svg";
export { ForwardRef as ReactComponent };